import { render, staticRenderFns } from "./DirectoryModuleDevice.vue?vue&type=template&id=72ea5ea6&"
import script from "./DirectoryModuleDevice.vue?vue&type=script&lang=js&"
export * from "./DirectoryModuleDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports